export const SAVE_LOCATION_TYPE_MODAL = 'locationTypeModal';
